/**
 * TABS COMPONENT
 */
class LandingPageProductTabs extends HTMLElement {
  constructor() {
    super();
    this.addedProductText = "ADDED TO BAG";
    this.addingProductText = "ADDING PRODUCT TO BAG...";
  }

  /**
   * Callback invoked when the element is inserted into the DOM.
   */
  connectedCallback() {
    this.section = this;
    this.productTabsThumbnails = this.section.querySelector(
      "#product-tabs-thumbnails"
    );

    this.section.addEventListener("click", (event) => {
      const addToCartBtn = event.target.closest(".product-tab-add-to-cart");
      if (!addToCartBtn) return;
      const { variantId } = addToCartBtn.dataset;
      this.addToCartEvenHandler(variantId, addToCartBtn);
    });

    this.productTabsThumbnails.addEventListener(
      "click",
      this.productTabsThumbnailsEventHandler.bind(this)
    );
  }

  /**
   * Callback invoked when the element is removed from the DOM.
   */
  disconnectedCallback() {
    this.productTabsThumbnails.removeEventListener(
      "click",
      this.productTabsThumbnailsEventHandler.bind(this)
    );
  }

  /**
   * Event handler for product tab filters.
   * @param {Event} event - The event object.
   */
  productTabsFiltersEventHandler(event) {
    const button = event.target.closest(".btn");
    if (!button) return;
    const { productTabHandle } = button.dataset;
    this.filterElements(productTabHandle);
  }

  /**
   * Event handler for product tab thumbnails.
   * @param {Event} event - The event object.
   */
  productTabsThumbnailsEventHandler(event) {
    const thumbnail = event.target.closest(".product-tab-thumbnail");
    if (!thumbnail) return;
    const { productTabHandle } = thumbnail.dataset;
    this.filterElements(productTabHandle);
  }

  /**
   * Filters elements based on the handle.
   * @param {string} handle - The handle to filter elements.
   */
  filterElements(handle) {
    this.removeProductTabThumbnailActiveState();
    this.removeProductTabContentActiveState();

    this.productTabsThumbnails.querySelector(
      `.product-tab-thumbnail[data-product-tab-handle="${handle}"]`
    ).dataset.productTabThumbnailSelected = true;

    this.section.querySelector(
      `.product-tab-content[data-product-tab-handle="${handle}"]`
    ).dataset.productTabContentSelected = true;
  }

  /**
   * Removes active state from product tab content.
   */
  removeProductTabThumbnailActiveState() {
    const thumbnail = this.productTabsThumbnails.querySelector(
      `.product-tab-thumbnail[data-product-tab-thumbnail-selected="true"]`
    );
    thumbnail.dataset.productTabThumbnailSelected = false;
  }

  /**
   * Removes active state from product tab content.
   */
  removeProductTabContentActiveState() {
    const contentTab = this.section.querySelector(
      `.product-tab-content[data-product-tab-content-selected="true"]`
    );
    contentTab.dataset.productTabContentSelected = false;
  }

  /**
   * Handles adding a product to the cart.
   * @param {string} variantId - The ID of the product variant.
   * @param {HTMLElement} addToCartBtn - The button used to add the product to the cart.
   */
  async addToCartEvenHandler(variantId, addToCartBtn) {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    try {
      addToCartBtn.innerHTML = this.addingProductText;
      addToCartBtn.disabled = true;
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.log(``);
    } finally {
      addToCartBtn.innerHTML = this.addedProductText;
    }
  }
}
customElements.define("landing-page-product-tabs", LandingPageProductTabs);

/**
 * SLIDER COMPONENT
 */
class ProductTabContentMedia extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this;
    this.swiperEl = this.section.querySelector(".swiper");
    this.pagination = this.section.querySelector(".swiper-pagination");
    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination } = _ref;
      this.slider = new Swiper(this.swiperEl, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        resistance: false,
        loop: true,
        pagination: {
          el: this.pagination,
          type: "bullets",
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          clickable: true,
        },
      });
    });
  }
  disconnectedCallback() {}
}
customElements.define("product-tab-content-media", ProductTabContentMedia);
